import { render, staticRenderFns } from "./WorkerCard.vue?vue&type=template&id=ea24149c&"
import script from "./WorkerCard.vue?vue&type=script&lang=js&"
export * from "./WorkerCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkerCard.vue?vue&type=style&index=0&id=ea24149c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports